/* eslint-disable import/prefer-default-export */

export const CLZ_UPDATE_FORM_STATUS = 'CLZ_UPDATE_FORM_STATUS';
export const CLZ_UPDATE_1BOD_INFO = 'CLZ_UPDATE_1BOD_INFO';
export const CLZ_SET_LOADING = 'CLZ_SET_LOADING';
export const CLZ_UPDATE_STEP = 'CLZ_UPDATE_STEP';
export const CLZ_CLEAR_1BOD_INFO = 'CLZ_CLEAR_1BOD_INFO';
export const CLZ_SET_APPLICATION_TYPE = 'CLZ_SET_APPLICATION_TYPE';
export const OFFERS_FOUND = 'FOUND';
// export const REGEX = {
//   INDIVIDUAL_TIPPER_HASH: /\w{12}/,
// };
export const NEW_BOD_UPDATE_OTP_VALUES = 'NEW_BOD_UPDATE_OTP_VALUES';
export const DEFAULT_CREDIT_AMOUNT = 30;
export const DEFAULT_TENOR = 0;
export const IMAGE_MAX_SIZE = 500;
export const UPDATE_BOD_APPLICATION_ID = 'UPDATE_BOD_APPLICATION_ID';
export const UPDATE_LIST_REGION = 'UPDATE_LIST_REGION';
export const UPDATE_LIST_DISTRICT = 'UPDATE_LIST_DISTRICT';
export const UPDATE_LIST_TOWN = 'UPDATE_LIST_TOWN';
export const SET_SELECTED_POS = 'SET_SELECTED_POS';

export const STORE_TRACKING_TOKEN = 'STORE_TRACKING_TOKEN';
export const NEW_BOD_UPDATE_SCORING_TOKEN = 'NEW_BOD_UPDATE_SCORING_TOKEN';
export const CLZ_CHECK_EXIST_USER = 'CLZ_CHECK_EXIST_USER';
export const CLZ_TOGGLE_INSURANCE = 'CLZ_TOGGLE_INSURANCE';

export const SET_CUSTOM_ERROR = 'SET_CUSTOM_ERROR';

export const NEW_BOD_UPDATE_USER_INFORMATION =
  'NEW_BOD_UPDATE_USER_INFORMATION';
export const NEW_BOD_UPDATE_VERIFICATION_ID = 'NEW_BOD_UPDATE_VERIFICATION_ID';

export const NEW_BOD_UPDATE_USER_TOKEN = 'NEW_BOD_UPDATE_USER_TOKEN';
export const PARTIAL_DEDUPLICATION = 'PARTIAL_DEDUPLICATION';
export const PARTIAL_DEDUPLICATION_OUT_TIME = 'PARTIAL_DEDUPLICATION_OUT_TIME';
export const ALREADY_EXISTING = 'ALREADY_EXISTING';
export const ALREADY_EXISTING_AS_NEW = 'ALREADY_EXISTING_AS_NEW';
export const CREATED = 'CREATED';
export const NEW_BOD_UPDATE_OFFERS = 'NEW_BOD_UPDATE_OFFERS';
export const NEW_BOD_LOADING = 'NEW_BOD_LOADING';
export const RECAL_STATUS_APPROVED = 'APPROVED';
export const NEW_BOD_UPDATE_OFFER_TENORS = 'NEW_BOD_UPDATE_OFFER_TENORS';
export const PRE_APPROVED = 'PREAPPROVED';
export const REJECTED = 'REJECTED';
export const CANCELLED = 'CANCELLED';
export const NO_OFFERS_CREATED = 'NO_OFFERS_CREATED';
export const NEW_BOD_UPDATE_SA_CODE = 'NEW_BOD_UPDATE_SA_CODE';
export const NEW_BOD_UTM_LINK = 'NEW_BOD_UTM_LINK';

export const SET_CONTRACT_INFO = 'SET_CONTRACT_INFO';

export const APPOINTMENT_HOURS = [
  {
    start: 8,
    end: 10,
  },
  {
    start: 10,
    end: 12,
  },
  {
    start: 12,
    end: 14,
  },
  {
    start: 14,
    end: 16,
  },
  {
    start: 16,
    end: 18,
  },
  {
    start: 18,
    end: 20,
  },
];
export const LASTEST_APPOINTMENT_HOUR = Math.max(
  ...APPOINTMENT_HOURS.map(timeRange => timeRange.end),
);
